import map from "lodash/map";

const getWeekColumn = (weeks, templateType) => {
  return map(weeks, (week, index) => {
    switch (templateType) {
      case 1:
        return {
          title: `Week-${index + 1}`,
          children: [
            {
              title: "Count",
              key: "count",
              dataIndex: ["report", index, "counts"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Operator Efficiency",
              key: "operator_efficiency",
              dataIndex: ["report", index, "operator_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["report", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 2:
        return {
          title: `Week-${index + 1}`,
          children: [
            {
              title: "Length (in meter)",
              key: "length",
              dataIndex: ["report", index, "length"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Operator Efficiency",
              key: "operator_efficiency",
              dataIndex: ["report", index, "operator_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["report", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 3:
        return {
          title: `Week-${index + 1}`,
          children: [
            {
              title: "Count",
              key: "count",
              dataIndex: ["report", index, "count"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Operator Efficiency",
              key: "operator_efficiency",
              dataIndex: ["report", index, "operator_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["report", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 4:
        return {
          title: `Week-${index + 1}`,
          children: [
            {
              title: "Counts",
              key: "counts",
              render: (value) => (value ? value : 0),
              dataIndex: ["report", index, "counts"],
            },
            {
              title: "Operator Efficiency",
              key: "operator_efficiency",
              dataIndex: ["report", index, "operator_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["report", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
    }
  });
};

const getWeekSummaryColumn = (templateType) => {
  switch (templateType) {
    case 1:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Counts",
            key: "counts",
            dataIndex: ["summary", "counts"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Operator Efficiency",
            key: "operator_efficiency",
            dataIndex: ["summary", "operator_efficiency"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
        ],
      };
    case 2:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Length",
            key: "length",
            dataIndex: ["summary", "length"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Operator Efficiency",
            key: "operator_efficiency",
            dataIndex: ["summary", "operator_efficiency"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
        ],
      };
    case 3:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Count",
            key: "count",
            dataIndex: ["summary", "count"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Operator Efficiency",
            key: "operator_efficiency",
            dataIndex: ["summary", "operator_efficiency"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
        ],
      };
    case 4:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Counts",
            key: "counts",
            dataIndex: ["summary", "counts"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Operator Efficiency",
            key: "operator_efficiency",
            dataIndex: ["summary", "operator_efficiency"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            fixed: "right",
            render: (value) => (value ? value : 0),
          },
        ],
      };
  }
}

export const getOperatorSummaryColumns = (weeks, templateType) => {
  const weekColumn = getWeekColumn(weeks, templateType);
  const weekSummaryColumn = getWeekSummaryColumn(templateType)
  return [
    {
      title: "Operator",
      fixed: "left",
      dataIndex: "name",
    },
    ...weekColumn,
    weekSummaryColumn
  ];
};
